module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-13.d20a8152.png";